<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_739)">
    <rect
      x="4.2897"
      y="4.78971"
      width="16.4206"
      height="16.4206"
      rx="8.21029"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-miterlimit="10"
    />
    <mask
      id="path-2-outside-1_86_739"
      maskUnits="userSpaceOnUse"
      x="6.35236"
      y="6.67812"
      width="13"
      height="13"
      fill="black"
    >
      <rect fill="white" x="6.35236" y="6.67812" width="13" height="13" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.1174 9.12125C13.1174 8.87652 12.919 8.67812 12.6742 8.67812C12.4295 8.67812 12.2311 8.87652 12.2311 9.12125V12.5569L8.79548 12.5569C8.55075 12.5569 8.35236 12.7553 8.35236 13C8.35236 13.2447 8.55075 13.4431 8.79548 13.4431L12.2311 13.4431V16.8788C12.2311 17.1235 12.4295 17.3219 12.6742 17.3219C12.919 17.3219 13.1174 17.1235 13.1174 16.8788V13.4431L16.553 13.4431C16.7977 13.4431 16.9961 13.2447 16.9961 13C16.9961 12.7553 16.7977 12.5569 16.553 12.5569L13.1174 12.5569V9.12125Z"
      />
    </mask>
    <path
      d="M12.2311 12.5569L12.2311 14.3069L13.9811 14.3069V12.5569H12.2311ZM8.79548 12.5569L8.79548 10.8069H8.79548V12.5569ZM8.35236 13H6.60236H8.35236ZM8.79548 13.4431L8.79548 11.6931H8.79548V13.4431ZM12.2311 13.4431H13.9811V11.6931L12.2311 11.6931L12.2311 13.4431ZM13.1174 13.4431V11.6931L11.3674 11.6931V13.4431H13.1174ZM16.553 13.4431V15.1931V13.4431ZM16.553 12.5569V14.3069V12.5569ZM13.1174 12.5569H11.3674V14.3069H13.1174V12.5569ZM12.6742 10.4281C11.9525 10.4281 11.3674 9.84302 11.3674 9.12125H14.8674C14.8674 7.91002 13.8855 6.92812 12.6742 6.92812V10.4281ZM13.9811 9.12125C13.9811 9.84302 13.396 10.4281 12.6742 10.4281V6.92812C11.463 6.92812 10.4811 7.91002 10.4811 9.12125H13.9811ZM13.9811 12.5569V9.12125H10.4811V12.5569H13.9811ZM8.79548 14.3069H12.2311L12.2311 10.8069L8.79548 10.8069L8.79548 14.3069ZM10.1024 13C10.1024 13.7218 9.51725 14.3069 8.79548 14.3069V10.8069C7.58425 10.8069 6.60236 11.7888 6.60236 13H10.1024ZM8.79548 11.6931C9.51725 11.6931 10.1024 12.2782 10.1024 13H6.60236C6.60236 14.2112 7.58425 15.1931 8.79548 15.1931V11.6931ZM12.2311 11.6931L8.79548 11.6931L8.79548 15.1931L12.2311 15.1931L12.2311 11.6931ZM13.9811 16.8788V13.4431H10.4811V16.8788H13.9811ZM12.6742 15.5719C13.396 15.5719 13.9811 16.157 13.9811 16.8788H10.4811C10.4811 18.09 11.463 19.0719 12.6742 19.0719V15.5719ZM11.3674 16.8788C11.3674 16.157 11.9525 15.5719 12.6742 15.5719V19.0719C13.8855 19.0719 14.8674 18.09 14.8674 16.8788H11.3674ZM11.3674 13.4431V16.8788H14.8674V13.4431H11.3674ZM16.553 11.6931L13.1174 11.6931L13.1174 15.1931L16.553 15.1931V11.6931ZM15.2461 13C15.2461 12.2782 15.8312 11.6931 16.553 11.6931V15.1931C17.7642 15.1931 18.7461 14.2112 18.7461 13H15.2461ZM16.553 14.3069C15.8312 14.3069 15.2461 13.7218 15.2461 13H18.7461C18.7461 11.7888 17.7642 10.8069 16.553 10.8069V14.3069ZM13.1174 14.3069H16.553V10.8069L13.1174 10.8069V14.3069ZM11.3674 9.12125V12.5569H14.8674V9.12125H11.3674Z"
      fill="currentColor"
      mask="url(#path-2-outside-1_86_739)"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_739">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
